import { Button, Flex, FormControl, Select, useToast } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { garpApi } from '@texas/api/endpoints/erp/garpApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { ConfigurationPage } from '@texas/components/configuration/layout/ConfigurationPage';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { TexasFormLabel } from '@texas/components/shared/form/TexasFormLabel';
import { useActiveSession } from '@texas/hooks/useSession';
import {
  getConfigurationBranchId,
  setConfigurationBranchId,
} from '../configurationBranch';

export function GarpConfiguration() {
  const { t } = useTranslation();
  const { branches } = useActiveSession();
  const toast = useToast();
  const [branchId, setBranchId] = useState(() =>
    getConfigurationBranchId(branches),
  );
  const {
    request: importMetadata,
    loading: importingMetadata,
    error: metadataError,
  } = useApiRequest(garpApi.importMetadata);
  const {
    request: importMatrixNodes,
    loading: importingNodes,
    error: nodesError,
  } = useApiRequest(garpApi.importMatrixNodes);

  const run = async (action: () => ReturnType<typeof importMatrixNodes>) => {
    const response = await action();
    if (!response.hasError) {
      toast({
        title: t('general.updated'),
        status: 'success',
        isClosable: true,
      });
    }
  };

  return (
    <ConfigurationPage title={t('configuration.navigation.garp')}>
      <Flex direction="column" gap="4">
        <ErrorDetails error={metadataError ?? nodesError} />
        <FormControl w="240px">
          <TexasFormLabel>{t('general.branch')}</TexasFormLabel>
          <Select
            variant="entityDirectory"
            value={branchId}
            onChange={(event) => {
              const id = Number(event.target.value);
              setConfigurationBranchId(id);
              setBranchId(id);
            }}
          >
            {branches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.name}
              </option>
            ))}
          </Select>
        </FormControl>
        <Flex gap="3" wrap="wrap">
          <Button
            variant="entityDirectoryPrimary"
            isDisabled={!branchId}
            isLoading={importingMetadata}
            onClick={() => run(() => importMetadata(branchId))}
          >
            {t('configuration.importMetadata')}
          </Button>
          <Button
            variant="entityDirectoryPrimary"
            isLoading={importingNodes}
            onClick={() => run(importMatrixNodes)}
          >
            {t('configuration.importMatrixNodes')}
          </Button>
        </Flex>
      </Flex>
    </ConfigurationPage>
  );
}
